package gr.tech.pdfgenerator.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleNotch
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*

@Composable
fun loadingSpinner(
    iconSize: IconSize = IconSize.XL,
    modifier: Modifier = Modifier
) {
    FaCircleNotch(
        size = iconSize,
        modifier = Modifier
            .animation(grLoadingSpinnerAnimation.toAnimation(
                duration = 2000.ms,
                timingFunction = AnimationTimingFunction.Linear,
                iterationCount = AnimationIterationCount.Infinite
            ))
            .color(Colors.DarkGray)
            .then(modifier)
    )
}

val grLoadingSpinnerAnimation = Keyframes {
    0.percent {
        Modifier.rotate(0.deg)
    }
    100.percent {
        Modifier.rotate(360.deg)
    }
}